import { configureStore } from '@reduxjs/toolkit'
import userSlice from './user'
import refreshSlice from './refresh'

export const store = configureStore({
  reducer: {
    user: userSlice,
    refresh: refreshSlice
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
